import { useUnderwritingStore } from '../../store/underwritingStore'

const fmt = (n) => '$' + n.toLocaleString()
const fmtMo = (n) => '$' + Math.round(n / 12).toLocaleString() + '/mo'
const pct = (n) => (n * 100).toFixed(1) + '%'

export default function AssumptionsPanel() {
  const { scenarios } = useUnderwritingStore()
  const { base, best, worst } = scenarios

  const sections = [
    {
      title: 'Income (Annual)',
      rows: [
        { label: 'Gross Rental Income (Annual)',    base: fmt(base.grossRentalIncome), best: fmt(best.grossRentalIncome), worst: fmt(worst.grossRentalIncome) },
        { label: 'Gross Rental Income (Monthly)',   base: fmtMo(base.grossRentalIncome), best: fmtMo(best.grossRentalIncome), worst: fmtMo(worst.grossRentalIncome) },
        { label: 'Other Income (Annual)',            base: fmt(base.otherIncome),       best: fmt(best.otherIncome),       worst: fmt(worst.otherIncome) },
        { label: 'Vacancy Rate',                     base: pct(base.vacancyRate),       best: pct(best.vacancyRate),       worst: pct(worst.vacancyRate) },
        { label: 'Annual Rent Growth',               base: pct(base.annualRentGrowth),  best: pct(best.annualRentGrowth),  worst: pct(worst.annualRentGrowth) },
      ],
    },
    {
      title: 'Operating Expenses (Annual / Monthly)',
      rows: [
        { label: 'Property Tax (Annual)',        base: fmt(base.propertyTax),  best: fmt(best.propertyTax),  worst: fmt(worst.propertyTax) },
        { label: 'Property Tax (Monthly)',       base: fmtMo(base.propertyTax), best: fmtMo(best.propertyTax), worst: fmtMo(worst.propertyTax) },
        {
          label: base.insuranceIsEstimated ? 'Insurance — Annual (estimated)' : 'Insurance (Annual)',
          base: fmt(base.insurance),  best: fmt(best.insurance),  worst: fmt(worst.insurance),
        },
        {
          label: base.insuranceIsEstimated ? 'Insurance — Monthly (estimated)' : 'Insurance (Monthly)',
          base: fmtMo(base.insurance), best: fmtMo(best.insurance), worst: fmtMo(worst.insurance),
        },
        { label: 'Utilities (Annual)',           base: fmt(base.utilities),    best: fmt(best.utilities),    worst: fmt(worst.utilities) },
        { label: 'Maintenance & Repairs (Annual)',base: fmt(base.maintenance), best: fmt(best.maintenance),  worst: fmt(worst.maintenance) },
        { label: 'Management Fee',               base: pct(base.managementPct),best: pct(best.managementPct),worst: pct(worst.managementPct) },
        { label: 'Reserves (Annual)',             base: fmt(base.reserves),    best: fmt(best.reserves),     worst: fmt(worst.reserves) },
        { label: 'Annual Expense Growth',         base: pct(base.annualExpenseGrowth), best: pct(best.annualExpenseGrowth), worst: pct(worst.annualExpenseGrowth) },
      ],
    },
    {
      title: 'Financing',
      rows: [
        { label: 'Purchase Price',          base: fmt(base.purchasePrice), best: fmt(best.purchasePrice), worst: fmt(worst.purchasePrice) },
        { label: 'Loan Amount',             base: fmt(base.loanAmount),    best: fmt(best.loanAmount),    worst: fmt(worst.loanAmount) },
        { label: 'Interest Rate',           base: pct(base.interestRate),  best: pct(best.interestRate),  worst: pct(worst.interestRate) },
        { label: 'Amortization',            base: `${base.amortization} yr`, best: `${best.amortization} yr`, worst: `${worst.amortization} yr` },
      ],
    },
    {
      title: 'Exit / Hold',
      rows: [
        { label: 'Hold Period',             base: `${base.holdYears} yr`,  best: `${best.holdYears} yr`,  worst: `${worst.holdYears} yr` },
        { label: 'Exit Cap Rate',           base: pct(base.exitCapRate),   best: pct(best.exitCapRate),   worst: pct(worst.exitCapRate) },
      ],
    },
  ]

  return (
    <div className="uw-assumptions">
      <h3 className="uw-section-title">Underwriting Assumptions</h3>
      <p className="uw-cf-desc">
        All inputs used to calculate the three scenarios. The only difference between scenarios is how
        optimistic or conservative each input is — the same financial model runs underneath all three.
      </p>

      <div className="uw-assump-header-row">
        <span>Assumption</span>
        <span className="uw-ah-best">📈 Best</span>
        <span className="uw-ah-base">📊 Base</span>
        <span className="uw-ah-worst">📉 Worst</span>
      </div>

      {sections.map(section => (
        <div key={section.title} className="uw-assump-section">
          <div className="uw-assump-section-title">{section.title}</div>
          {section.rows.map(row => (
            <div key={row.label} className="uw-assump-row">
              <span className="uw-assump-label">{row.label}</span>
              <span className="uw-assump-best">{row.best}</span>
              <span className="uw-assump-base">{row.base}</span>
              <span className="uw-assump-worst">{row.worst}</span>
            </div>
          ))}
        </div>
      ))}

      <div className="uw-cf-note">
        These assumptions are pre-populated from your uploaded OM, T12, and Rent Roll (Module 1). Adjust them in the deal settings to re-run underwriting with custom inputs.
      </div>
    </div>
  )
}
